<div class="card card-custom" style="height: 100%">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">DRPs</h3>
    </div>
  </div>
  <div class="navi-hover scroll card-body" style="max-height: 80vh; padding-top: 0">
    <kt-drp-dashboard [patient]="data.patient"></kt-drp-dashboard>
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col-lg-9"></div>
      <div class="col-lg-3" style="text-align: right">
        <button
          (click)="close()"
          type="button"
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
        >
          <span translate="GLOBAL.CLOSE">Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
